import { render } from "./change.vue?vue&type=template&id=2bce9c6c"
import script from "./change.vue?vue&type=script&lang=js"
export * from "./change.vue?vue&type=script&lang=js"

import "./change.vue?vue&type=style&index=0&id=2bce9c6c&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__